export default __webpack_public_path__ + "static/media/hotel2.fac0fc2d.png";